/* Footer banner: auto-rotate + dot navigation + swipe sync */
(function () {
  function initSlider(root) {
    var track = root.querySelector('.etq-footer__banner-track');
    var slides = root.querySelectorAll('.etq-footer__banner-slide');
    var dots = root.querySelectorAll('.etq-footer__banner-dot');
    if (!track || slides.length < 2) return;

    var current = 0;
    var timer;

    function goTo(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * current, behavior: 'smooth' });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
    }

    function start() {
      stop();
      timer = setInterval(function () { goTo(current + 1); }, 4000);
    }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-slide'), 10));
        start();
      });
    });

    track.addEventListener('scroll', function () {
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      if (idx !== current) {
        current = idx;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      }
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  }

  function init() {
    document.querySelectorAll('[data-etq-footer-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();